import React from 'react';

const IconSwatchRequest = ({
  className = '',
  color = '#27919C',
  height = '34',
  width = '34',
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 500 500"
  >
    <polyline
      className="st0"
      fillRule="evenodd"
      fill="none"
      strokeLinejoin="round"
      strokeWidth="15px"
      stroke={color}
      points="212.36 287.3 222.28 315.57 78.68 365.95 28.29 222.35 171.9 171.96"
    />
    <polyline
      className="st0"
      fillRule="evenodd"
      fill="none"
      strokeLinejoin="round"
      strokeWidth="15px"
      stroke={color}
      points="287.64 287.3 277.72 315.57 421.32 365.95 471.71 222.35 328.1 171.96"
    />
    <rect
      className="st2"
      fill="none"
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="15px"
      x="173.91"
      y="135.11"
      width="152.19"
      height="152.19"
    />
    <g>
      <line
        className="st1"
        fill="none"
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="15.71px"
        x1="234.14"
        y1="137.17"
        x2="173.91"
        y2="197.41"
      />
      <line
        className="st1"
        fill="none"
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="15.71px"
        x1="295.5"
        y1="134.05"
        x2="173.91"
        y2="255.64"
      />
      <line
        className="st1"
        fill="none"
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="15.71px"
        x1="326.09"
        y1="163.5"
        x2="202.99"
        y2="286.61"
      />
      <line
        className="st1"
        fill="none"
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="15.71px"
        x1="324.15"
        y1="225.5"
        x2="263.71"
        y2="285.94"
      />
    </g>
    <g>
      <circle className="st3" fill={color} cx="349.33" cy="216.32" r="8.98" />
      <circle className="st3" fill={color} cx="386.4" cy="229.33" r="8.98" />
      <circle className="st3" fill={color} cx="423.47" cy="242.33" r="8.98" />
      <circle className="st3" fill={color} cx="335.42" cy="255.95" r="8.98" />
      <circle className="st3" fill={color} cx="372.49" cy="268.96" r="8.98" />
      <circle className="st3" fill={color} cx="409.57" cy="281.97" r="8.98" />
      <circle className="st3" fill={color} cx="321.52" cy="295.59" r="8.98" />
      <circle className="st3" fill={color} cx="358.59" cy="308.59" r="8.98" />
      <circle className="st3" fill={color} cx="395.66" cy="321.6" r="8.98" />
    </g>
  </svg>
);

export default IconSwatchRequest;
